module.exports = __webpack_public_path__ + "static/media/arrow-left.ba4ca32f.svg";